/*
 * Local, strict-mode-safe copy of Shopify's legacy option_selection.js helper.
 *
 * Why this file exists:
 * The Shopify-hosted helper deployed on 2026-09-04 declares `property`
 * implicitly inside Shopify.Product#update. The hosted file now runs in
 * strict mode, so that implicit global throws a ReferenceError and prevents
 * every multi-variant product selector from initializing.
 *
 * Keep this local copy until the theme is migrated away from the legacy
 * Shopify.OptionSelectors API. The only behavioral fix relative to the
 * upstream helper is the explicitly declared loop variable in `update`.
 */
(function () {
  'use strict';

  if (typeof window.Shopify === 'undefined') {
    window.Shopify = {};
  }

  var Shopify = window.Shopify;

  Shopify.each = function (array, callback) {
    for (var index = 0; index < array.length; index += 1) {
      callback(array[index], index);
    }
  };

  Shopify.map = function (array, callback) {
    var result = [];
    for (var index = 0; index < array.length; index += 1) {
      result.push(callback(array[index], index));
    }
    return result;
  };

  Shopify.arrayIncludes = function (array, object) {
    for (var index = 0; index < array.length; index += 1) {
      if (array[index] == object) {
        return true;
      }
    }
    return false;
  };

  Shopify.uniq = function (array) {
    var result = [];
    for (var index = 0; index < array.length; index += 1) {
      if (!Shopify.arrayIncludes(result, array[index])) {
        result.push(array[index]);
      }
    }
    return result;
  };

  Shopify.isDefined = function (object) {
    return typeof object !== 'undefined';
  };

  Shopify.getClass = function (object) {
    return Object.prototype.toString.call(object).slice(8, -1);
  };

  Shopify.extend = function (subClass, baseClass) {
    function Inheritance() {}
    Inheritance.prototype = baseClass.prototype;
    subClass.prototype = new Inheritance();
    subClass.prototype.constructor = subClass;
    subClass.baseConstructor = baseClass;
    subClass.superClass = baseClass.prototype;
  };

  Shopify.locationSearch = function () {
    return window.location.search;
  };

  Shopify.locationHash = function () {
    return window.location.hash;
  };

  Shopify.replaceState = function (newState) {
    window.history.replaceState({}, document.title, newState);
  };

  Shopify.urlParam = function (name) {
    var match = RegExp('[?&]' + name + '=([^&#]*)').exec(Shopify.locationSearch());
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
  };

  Shopify.newState = function (parameterKey, parameterValue) {
    var newState;

    if (Shopify.urlParam(parameterKey)) {
      newState = Shopify.locationSearch().replace(
        RegExp('(' + parameterKey + '=)[^&#]+'),
        '$1' + parameterValue
      );
    } else if (Shopify.locationSearch() === '') {
      newState = '?' + parameterKey + '=' + parameterValue;
    } else {
      newState = Shopify.locationSearch() + '&' + parameterKey + '=' + parameterValue;
    }

    return newState + Shopify.locationHash();
  };

  Shopify.setParam = function (parameterKey, parameterValue) {
    Shopify.replaceState(Shopify.newState(parameterKey, parameterValue));
  };

  Shopify.Product = function (json) {
    if (Shopify.isDefined(json)) {
      this.update(json);
    }
  };

  Shopify.Product.prototype.update = function (json) {
    // IMPORTANT: `property` must be declared because this file uses strict mode.
    for (var property in json) {
      if (Object.prototype.hasOwnProperty.call(json, property)) {
        this[property] = json[property];
      }
    }
  };

  Shopify.Product.prototype.optionNames = function () {
    if (Shopify.getClass(this.options) === 'Array') {
      return this.options;
    }
    return [];
  };

  Shopify.Product.prototype.optionValues = function (index) {
    if (!Shopify.isDefined(this.variants)) {
      return null;
    }

    var results = Shopify.map(this.variants, function (variant) {
      var optionColumn = 'option' + (index + 1);
      return variant[optionColumn] === undefined ? null : variant[optionColumn];
    });

    return results[0] === null ? null : Shopify.uniq(results);
  };

  Shopify.Product.prototype.getVariant = function (selectedValues) {
    var found = null;

    if (selectedValues.length !== this.options.length) {
      return found;
    }

    Shopify.each(this.variants, function (variant) {
      var satisfied = true;

      for (var index = 0; index < selectedValues.length; index += 1) {
        var optionColumn = 'option' + (index + 1);
        if (variant[optionColumn] != selectedValues[index]) {
          satisfied = false;
        }
      }

      if (satisfied) {
        found = variant;
      }
    });

    return found;
  };

  Shopify.Product.prototype.getVariantById = function (id) {
    for (var index = 0; index < this.variants.length; index += 1) {
      var variant = this.variants[index];
      if (id == variant.id) {
        return variant;
      }
    }
    return null;
  };

  Shopify.money_format = '${{amount}}';

  Shopify.formatMoney = function (cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || Shopify.money_format;

    function defaultOption(option, defaultValue) {
      return typeof option === 'undefined' ? defaultValue : option;
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var decimalValue = parts[1] ? decimal + parts[1] : '';
      return dollars + decimalValue;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  };

  Shopify.OptionSelectors = function (existingSelectorId, options) {
    this.selectorDivClass = 'selector-wrapper';
    this.selectorClass = 'single-option-selector';
    this.variantIdFieldIdSuffix = '-variant-id';
    this.variantIdField = null;
    this.historyState = null;
    this.selectors = [];
    this.domIdPrefix = existingSelectorId;
    this.product = new Shopify.Product(options.product);
    this.onVariantSelected = Shopify.isDefined(options.onVariantSelected)
      ? options.onVariantSelected
      : function () {};
    this.replaceSelector(existingSelectorId);
    this.initDropdown();

    if (options.enableHistoryState) {
      this.historyState = new Shopify.OptionSelectors.HistoryState(this);
    }

    return true;
  };

  Shopify.OptionSelectors.prototype.initDropdown = function () {
    var options = { initialLoad: true };
    var success = this.selectVariantFromDropdown(options);

    if (!success) {
      var self = this;
      window.setTimeout(function () {
        if (!self.selectVariantFromParams(options)) {
          self.fireOnChangeForFirstDropdown.call(self, options);
        }
      }, 0);
    }
  };

  Shopify.OptionSelectors.prototype.fireOnChangeForFirstDropdown = function (options) {
    this.selectors[0].element.onchange(options);
  };

  Shopify.OptionSelectors.prototype.selectVariantFromParamsOrDropdown = function (options) {
    if (!this.selectVariantFromParams(options)) {
      this.selectVariantFromDropdown(options);
    }
  };

  Shopify.OptionSelectors.prototype.replaceSelector = function (domId) {
    var oldSelector = document.getElementById(domId);
    var parent = oldSelector.parentNode;

    Shopify.each(this.buildSelectors(), function (element) {
      parent.insertBefore(element, oldSelector);
    });

    oldSelector.style.display = 'none';
    this.variantIdField = oldSelector;
  };

  Shopify.OptionSelectors.prototype.selectVariantFromDropdown = function (options) {
    var selector = document.getElementById(this.domIdPrefix);
    var option = selector.querySelector('[selected]');

    if (!option) {
      option = selector.querySelector('[selected="selected"]');
    }

    if (!option) {
      return false;
    }

    return this.selectVariant(option.value, options);
  };

  Shopify.OptionSelectors.prototype.selectVariantFromParams = function (options) {
    return this.selectVariant(Shopify.urlParam('variant'), options);
  };

  Shopify.OptionSelectors.prototype.selectVariant = function (variantId, options) {
    var variant = this.product.getVariantById(variantId);

    if (variant === null) {
      return false;
    }

    for (var index = 0; index < this.selectors.length; index += 1) {
      var element = this.selectors[index].element;
      var optionName = element.getAttribute('data-option');
      var value = variant[optionName];

      if (value === null || !this.optionExistInSelect(element, value)) {
        continue;
      }

      element.value = value;
    }

    if (typeof window.jQuery !== 'undefined') {
      window.jQuery(this.selectors[0].element).trigger('change', options);
    } else {
      this.selectors[0].element.onchange(options);
    }

    return true;
  };

  Shopify.OptionSelectors.prototype.optionExistInSelect = function (select, value) {
    for (var index = 0; index < select.options.length; index += 1) {
      if (select.options[index].value == value) {
        return true;
      }
    }
    return false;
  };

  Shopify.OptionSelectors.prototype.insertSelectors = function (domId, messageElementId) {
    if (Shopify.isDefined(messageElementId) && typeof this.setMessageElement === 'function') {
      this.setMessageElement(messageElementId);
    }

    this.domIdPrefix = 'product-' + this.product.id + '-variant-selector';
    var parent = document.getElementById(domId);

    Shopify.each(this.buildSelectors(), function (element) {
      parent.appendChild(element);
    });
  };

  Shopify.OptionSelectors.prototype.buildSelectors = function () {
    for (var index = 0; index < this.product.optionNames().length; index += 1) {
      var selector = new Shopify.SingleOptionSelector(
        this,
        index,
        this.product.optionNames()[index],
        this.product.optionValues(index)
      );
      selector.element.disabled = false;
      this.selectors.push(selector);
    }

    var divClass = this.selectorDivClass;
    var optionNames = this.product.optionNames();

    return Shopify.map(this.selectors, function (selector) {
      var wrapper = document.createElement('div');
      wrapper.setAttribute('class', divClass);

      if (optionNames.length > 1) {
        var label = document.createElement('label');
        label.htmlFor = selector.element.id;
        label.innerHTML = selector.name;
        wrapper.appendChild(label);
      }

      wrapper.appendChild(selector.element);
      return wrapper;
    });
  };

  Shopify.OptionSelectors.prototype.selectedValues = function () {
    var currentValues = [];

    for (var index = 0; index < this.selectors.length; index += 1) {
      currentValues.push(this.selectors[index].element.value);
    }

    return currentValues;
  };

  Shopify.OptionSelectors.prototype.updateSelectors = function (index, options) {
    var variant = this.product.getVariant(this.selectedValues());

    if (variant) {
      this.variantIdField.disabled = false;
      this.variantIdField.value = variant.id;
    } else {
      this.variantIdField.disabled = true;
    }

    this.onVariantSelected(variant, this, options);

    if (this.historyState !== null) {
      this.historyState.onVariantChange(variant, this, options);
    }
  };

  Shopify.OptionSelectorsFromDOM = function (existingSelectorId, options) {
    var optionNames = options.optionNames || [];
    var priceFieldExists = options.priceFieldExists || true;
    var delimiter = options.delimiter || '/';
    var product = this.createProductFromSelector(
      existingSelectorId,
      optionNames,
      priceFieldExists,
      delimiter
    );

    options.product = product;
    Shopify.OptionSelectorsFromDOM.baseConstructor.call(this, existingSelectorId, options);
  };

  Shopify.extend(Shopify.OptionSelectorsFromDOM, Shopify.OptionSelectors);

  Shopify.OptionSelectorsFromDOM.prototype.createProductFromSelector = function (
    domId,
    optionNames,
    priceFieldExists,
    delimiter
  ) {
    if (!Shopify.isDefined(priceFieldExists)) {
      priceFieldExists = true;
    }
    if (!Shopify.isDefined(delimiter)) {
      delimiter = '/';
    }

    var oldSelector = document.getElementById(domId);
    var options = oldSelector.childNodes;
    var optionCount = optionNames.length;
    var variants = [];

    Shopify.each(options, function (option) {
      if (option.nodeType === 1 && option.tagName.toLowerCase() === 'option') {
        var chunks = option.innerHTML.split(new RegExp('\\s*\\' + delimiter + '\\s*'));

        if (optionNames.length === 0) {
          optionCount = chunks.length - (priceFieldExists ? 1 : 0);
        }

        var optionValues = chunks.slice(0, optionCount);
        var message = priceFieldExists ? chunks[optionCount] : '';
        variants.push({
          available: !option.disabled,
          id: parseFloat(option.value),
          price: message,
          option1: optionValues[0],
          option2: optionValues[1],
          option3: optionValues[2]
        });
      }
    });

    var updateObject = { variants: variants };

    if (optionNames.length === 0) {
      updateObject.options = [];
      for (var index = 0; index < optionCount; index += 1) {
        updateObject.options[index] = 'option ' + (index + 1);
      }
    } else {
      updateObject.options = optionNames;
    }

    return updateObject;
  };

  Shopify.SingleOptionSelector = function (multiSelector, index, name, values) {
    this.multiSelector = multiSelector;
    this.values = values;
    this.index = index;
    this.name = name;
    this.element = document.createElement('select');

    for (var valueIndex = 0; valueIndex < values.length; valueIndex += 1) {
      var option = document.createElement('option');
      option.value = values[valueIndex];
      option.innerHTML = values[valueIndex];
      this.element.appendChild(option);
    }

    this.element.setAttribute('class', this.multiSelector.selectorClass);
    this.element.setAttribute('data-option', 'option' + (index + 1));
    this.element.id = multiSelector.domIdPrefix + '-option-' + index;
    this.element.onchange = function (event, options) {
      multiSelector.updateSelectors(index, options || {});
    };

    return true;
  };

  Shopify.Image = {
    preload: function (images, size) {
      for (var index = 0; index < images.length; index += 1) {
        this.loadImage(this.getSizedImageUrl(images[index], size));
      }
    },

    loadImage: function (path) {
      new window.Image().src = path;
    },

    switchImage: function (image, element, callback) {
      if (!image || !element) {
        return;
      }

      var size = this.imageSize(element.src);
      var imageUrl = this.getSizedImageUrl(image.src, size);

      if (callback) {
        callback(imageUrl, image, element);
      } else {
        element.src = imageUrl;
      }
    },

    imageSize: function (source) {
      var match = source.match(
        /.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/
      );
      return match !== null ? match[1] : null;
    },

    getSizedImageUrl: function (source, size) {
      if (size === null) {
        return source;
      }
      if (size === 'master') {
        return this.removeProtocol(source);
      }

      var match = source.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?.*)?$/i);

      if (match !== null) {
        var prefix = source.split(match[0]);
        return this.removeProtocol(prefix[0] + '_' + size + match[0]);
      }

      return null;
    },

    removeProtocol: function (path) {
      return path.replace(/http(s)?:/, '');
    }
  };

  Shopify.OptionSelectors.HistoryState = function (optionSelector) {
    if (this.browserSupports()) {
      this.register(optionSelector);
    }
  };

  Shopify.OptionSelectors.HistoryState.prototype.register = function (optionSelector) {
    window.addEventListener('popstate', function () {
      optionSelector.selectVariantFromParamsOrDropdown({ popStateCall: true });
    });
  };

  Shopify.OptionSelectors.HistoryState.prototype.onVariantChange = function (
    variant,
    selector,
    data
  ) {
    if (this.browserSupports() && variant && !data.initialLoad && !data.popStateCall) {
      Shopify.setParam('variant', variant.id);
    }
  };

  Shopify.OptionSelectors.HistoryState.prototype.browserSupports = function () {
    return window.history && window.history.replaceState;
  };
})();
